// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/pc.scss
// module id = 247
// module chunks = 0